import { createSelector } from 'reselect'
import { identity, prop } from 'ramda'

export const customerSelector = createSelector(prop('customer'), identity)
